import PropTypes from 'prop-types';

const EventType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  kind: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  created_at: PropTypes.string.isRequired,
});

export default EventType;



// WEBPACK FOOTER //
// ./client/app/shared/types/event.js